<template>
  <h1>LogOut</h1>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/auth'

  export default {
    name: "logout",
    data() {
      return {
        isLoggedIn: false,
        currentUser: false
      }
    },
    methods: {
      logout: function() { // Método para salir del firebase
        firebase.auth().signOut().then(() => {
          this.$router.push('/login');
        });
      }
    },
    beforeMount() {
      this.logout();
    }
  }
</script>

<style scoped>

</style>
